import React, { useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { Icon } from "dyl-components";
import "./index.scss";

const ViewMore = ({
    text,
    maxLength,
    viewMoreLabel,
    viewLessLabel,
    className,
    iconClassName,
    showIcon,
    onToggle,
    initiallyExpanded,
}) => {
    const [expanded, setExpanded] = useState(initiallyExpanded);

    const isLongText = text?.length > maxLength;

    const handleToggle = useCallback(() => {
        setExpanded((prev) => {
            const newState = !prev;
            onToggle?.(newState);
            return newState;
        });
    }, [onToggle]);

    const displayText = useMemo(() => {
        return isLongText && !expanded
            ? text?.slice?.(0, maxLength) + "..."
            : text;
    }, [expanded, maxLength, text, isLongText]);

    return (
        <div className={`ExpandableText ${className}`}>
            <span>{displayText}</span>

            {isLongText && (
                <>
                    <br />
                    <span
                        className="ExpandableText__ToggleButton"
                        onClick={handleToggle}
                    >
                        {expanded ? viewLessLabel : viewMoreLabel}
                        {showIcon && (
                            <Icon
                                className={`ExpandableText__Icon ${iconClassName} fa-chevron-${
                                    expanded ? "up" : "down"
                                }`}
                            />
                        )}
                    </span>
                </>
            )}
        </div>
    );
};

ViewMore.propTypes = {
    text: PropTypes.string.isRequired,
    maxLength: PropTypes.number,
    viewMoreLabel: PropTypes.string,
    viewLessLabel: PropTypes.string,
    className: PropTypes.string,
    iconClassName: PropTypes.string,
    showIcon: PropTypes.bool,
    onToggle: PropTypes.func,
    initiallyExpanded: PropTypes.bool,
};

ViewMore.defaultProps = {
    maxLength: 64,
    viewMoreLabel: "view more",
    viewLessLabel: "view less",
    className: "",
    iconClassName: "fa-solid blue",
    showIcon: true,
    onToggle: null,
    initiallyExpanded: false,
};

export default ViewMore;
